

export default function NotFoundPage() {

  return (
    <div role="alert" className={"m-32"}>
      <p>Siden findes ikke.</p>
    </div>
  )

}
